export function AtendimentoComentarioResource($resource: any, URL_API_ATENDIMENTO: string) {
  return $resource(URL_API_ATENDIMENTO + '/atendimentos/:ticketId/comentarios',
    { ticketId: '@ticketId' }
  );
}
